import MenuOutlined from '@mui/icons-material/MenuOutlined';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material';
import { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MiraLogo from '@/assets/images/logo/Mira-Logo_Mira-Only_Black.svg?react';
import { UserContext } from '@/providers/userContextProvider';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Sidebar from './sideBar';
import withInactivitySession from './withInactivitySession';
// import { useHourlyDataSync } from '@/hooks/useHourlySyncDS';
import { useApiMutation } from '@/hooks/useApi';
import { useProfile } from '@/hooks/useProfile';
import StaffButton from '@/pages/staff/components/StaffButton';
// import StatsHeader from './statsHeader';

const Layout = () => {
  const { pathname } = useLocation();
  const { closed, setClosed, setMobileOpen, mobileOpen } =
    useContext(UserContext);
  const { profile } = useProfile();
  const theme = useTheme();
  const toggleMobileMenu = () => {
    setClosed(false);
    setMobileOpen(!mobileOpen);
  };
  const { mutateAsync: fetchDataFromDS } = useApiMutation<
    void,
    { userId: string }
  >({
    url: '/triggerUserDataFetch/trigger-user-fetch',
    method: 'post',
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const key = 'lastDataSync';
    const userId = profile?.value[0].eXpMember.Uuid as string;
    if (!userId) return;
    fetchDataFromDS({ userId });
    localStorage.setItem(key, Date.now().toString());
    return () => {
      localStorage.removeItem(key);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Sync call after every hour if user is active for long time
  // useHourlyDataSync();
  return (
    <Box sx={{ height: '100dvh', overflow: 'hidden' }} data-testid="layout">
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          transition: 'all 0.3s',
          backgroundColor: theme.palette.background.default,
          height: '60px',
          display: {
            lg: 'none',
          },
        }}
        data-testid="layout-appbar"
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
          }}
          data-testid="layout-toolbar"
        >
          <MiraLogo
            data-testid="sidebar-logo"
            style={{
              width: '60px',
              height: 'auto',
              marginLeft: 10,
            }}
            color={theme.palette.mode !== 'dark' ? '#000000' : '#ffffffff'}
          />
          <IconButton
            onClick={toggleMobileMenu}
            size="small"
            sx={{ fontSize: '12px', m: 1 }}
            data-testid="layout-menu-button"
          >
            <MenuOutlined
              sx={{
                transform: !closed ? 'rotate(180deg)' : undefined,
                transition: 'all 0.4s',
                color: theme.palette.primary.main,
              }}
            />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        justifyContent="flex-start"
        alignItems="flex-start"
        display="flex"
        sx={{
          height: '100%',
        }}
        data-testid="layout-main-container"
      >
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100%',
            overflow: 'hidden',
            transition: 'margin .5s ease',
            ml: {
              xs: '0px',
              sm: '0px',
              md: '0px',
              lg: `${closed ? 52 : 320}px`,
            },
          }}
          data-testid="layout-main-content"
        >
          <Box
            sx={{
              height: '100%',
              overflow: 'auto',
            }}
            data-testid="layout-content-wrapper"
          >
            <StaffButton />
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default withInactivitySession(Layout);
